import store from './store';
import axios from 'axios';
import Vue from 'vue';

const baseUrl = window.location.origin;
axios.defaults.baseURL = baseUrl;

axios.interceptors.response.use(
  res => {
    return res;
  },
  error => {
    const res = error.response;
    const statusCode = res?.data?.status_code || res?.status;
    const {
      permission_failed,
      email,
      toggle_billing,
      encrypted_data,
      is_quota_based,
      is_action_restricted,
      active_user,
      limit,
      grace_period_remaining_days,
    } = res?.data?.data || '';
    /* eslint-disable camelcase */
    if (statusCode === 401) {
      localStorage.clear();
      store.dispatch('resetCookies');
      window.location = '/login';
    } else if (statusCode === 403) {
      if (permission_failed) window.location = `/permission-failed?email=${email}`;
      else {
        window.location = '/home/';
        Vue.$cookies.set('has-no-access');
      }
    } else if (statusCode === 404 && toggle_billing) {
      window.location = `/landing?data=${encrypted_data}`;
    } else if (statusCode === 422 && is_action_restricted) {
      // reset quota first for showing modal exceed after resubmit
      store.commit('SET_QUOTA_BASED', { is_quota_based: false, is_action_restricted: false });
      setTimeout(() => {
        store.commit('SET_QUOTA_BASED', {
          is_quota_based,
          is_action_restricted,
          quota: {
            active_user,
            limit,
            grace_period_remaining_days,
            is_submit_url: true, // if from submit, exceed modal will have close button
          },
        });
      }, 50);
    }
    /* eslint-enable camelcase */

    return error;
  },
);

axios.interceptors.request.use(function(config) {
  // Do something before request is sent
  const token = Vue.$cookies.get('token');
  config.headers.common.Authorization = `Bearer ${token}`;
  config.headers.isFromKong = false;
  return config;
});

const config = {
  production: {
    newEndPoint: 'https://review-service.talenta.co/api/v1/kpi',
    newNonCoreEndPoint: 'https://review-service.talenta.co/api/v1',
    endPoint: 'https://tapi.talenta.co/api/v1/kpi',
    endPoint2: 'https://tapi.talenta.co/api/v2/kpi',
    nonCoreEndPoint: 'https://tapi.talenta.co/api/v1',
    signInPath: 'https://talenta.co/employee/dashboard',
    intercomId: 'a5tlxzie',
    intercomHash: 'zZUtuDqGg4s5w5-pZ1yuHESOXznlZXwYuIEQf-qv',
    intercomActive: true,
    coreBaseURL: 'https://hr.talenta.co',
    imgPath: 'https://talenta.oss-ap-southeast-5.aliyuncs.com/avatar/',
    s3Path: 'https://talenta.oss-ap-southeast-5.aliyuncs.com/',
    tracingOriginsUrl: 'review.talenta.co',
    insight: 'https://insights.talenta.co',
    is_sso: true,
    sso: {
      url: 'https://account.mekari.com/',
      id: '47hMO3uR5wncUtAO',
    },
  },
  learning: {
    newEndPoint: 'https://sandbox-review-service.talenta.co/api/v1/kpi',
    newNonCoreEndPoint: 'https://sandbox-review-service.talenta.co/api/v1',
    endPoint: 'https://sandbox-tapi.talenta.co/api/v1/kpi',
    endPoint2: 'https://sandbox-tapi.talenta.co/api/v2/kpi',
    nonCoreEndPoint: 'https://sandbox-tapi.talenta.co/api/v1',
    signInPath: 'https://learning.talenta.co/employee/dashboard',
    coreBaseURL: 'https://sandbox-hr.talenta.co',
    tracingOriginsUrl: 'sandbox-review.talenta.co',
    insight: 'https://sandbox-insights.talenta.co',
    is_sso: true,
    sso: {
      url: 'https://sandbox-account.mekari.com/',
      id: 'HBzZQvzH8S5M7Qa1',
    },
  },
  staging: {
    newEndPoint: 'https://review-service-staging.talentadev.com/api/v1/kpi',
    newNonCoreEndPoint: 'https://review-service-staging.talentadev.com/api/v1',
    endPoint: 'https://tapi-staging.talentadev.com/api/v1/kpi',
    endPoint2: 'https://tapi-staging.talentadev.com/api/v2/kpi',
    nonCoreEndPoint: 'https://tapi-staging.talentadev.com/api/v1',
    signInPath: 'https://talenta-staging-core-growth-staging-growth.talentadev.com/employee/dashboard',
    intercomId: 'k69c0qqf',
    intercomHash: 'Awy10dleScK68TDoArJRX2tYtoFBRqSa6dq00n-9',
    intercomActive: true,
    coreBaseURL: 'https://talenta-staging-core-tepar-dev.talentadev.com',
    imgPath: 'https://talenta.oss-ap-southeast-5.aliyuncs.com/avatar/',
    s3Path: 'https://talenta.oss-ap-southeast-5.aliyuncs.com/',
    tracingOriginsUrl: 'review-staging.talentadev.com',
    insight: 'https://insights.talentadev.com',
    is_sso: false,
    sso: {
      url: 'https://account.mekari.io/',
      id: 'i0uugnehxUvWgLA4',
    },
  },
  ppe: {
    newEndPoint: 'https://review-service-ppe.talentadev.com/api/v1/kpi',
    newNonCoreEndPoint: 'https://review-service-ppe.talentadev.com/api/v1',
    endPoint: 'https://talenta-ppe-tapi.talentadev.com/api/v1/kpi',
    endPoint2: 'https://talenta-ppe-tapi.talentadev.com/api/v2/kpi',
    nonCoreEndPoint: 'https://talenta-ppe-tapi.talentadev.com/api/v1',
    signInPath: 'https://talenta-ppe-core.talentadev.com/employee/dashboard',
    intercomId: 'k69c0qqf',
    intercomHash: 'Awy10dleScK68TDoArJRX2tYtoFBRqSa6dq00n-9',
    intercomActive: true,
    coreBaseURL: 'https://talenta-ppe-core.talentadev.com',
    imgPath: 'https://talenta.oss-ap-southeast-5.aliyuncs.com/avatar/',
    s3Path: 'https://talenta.oss-ap-southeast-5.aliyuncs.com/',
    tracingOriginsUrl: 'talenta-ppe-review.talentadev.com',
    insight: 'https://talenta-ppe-insights.talentadev.com',
    is_sso: true,
    sso: {
      url: 'https://account.mekari.io/',
      id: 'I5KG09lT5wMqWMXM',
    },
  },
};

const host = window.location.hostname;
let server = config.staging;

// Service logic
if (host === 'localhost') {
  server = {
    ...config.ppe,
    is_sso: false,
    sso: {
      url: 'https://account.mekari.io/',
      id: '7zlxOIKJ9uEvFw9n', // different client_id for local (for redirection purpose)
    },

    // if need to develop sso, change is_sso to true. if error in generate token (in sso-callback), do:
    // in src/views/public/SSOCallback.vue, hardcode the email & password when hit getLoginToken
  };
} else if (host === 'review.talenta.co') {
  server = config.production;
} else if (host === 'sandbox-review.talenta.co') {
  server = config.learning;
} else if (host === 'review-staging.talentadev.com') {
  server = config.staging;
} else if (host === 'talenta-ppe-review.talentadev.com') {
  server = config.ppe;
}

const obj = server;

export default obj;
